import React from 'react'
import StakingEnabled from './StakingBlock/EnabledBlock/Preloader'

// TODO redesign: restyle

function Preloader() {
    return (
        <div data-pointer="staking_page_preloader">
            <StakingEnabled />
        </div>
    )
}

export default Preloader
